import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { permissionObj } from '../../../../../Helpers/permission';
import { TRAFFIC_SUB_VIEW_MODEL } from '../../Model/Model';
import CustomSearch from "../../../../../components/SearchSimples/CustomSearch";
import React from "react";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */

const ManageMainHeader = (props) => {
    const { subView, handleSubViewChange, searchElement, setSearchElement, permission, DEV } = props;

    return (
        <>
            <div className='d-flex'>
                <div className='d-flex'>
                    {(DEV || permission?.includes(permissionObj?.WEB_TRAFFIC_MANAGE_FINES_READ)) && (
                        <ButtonAction
                        id='btn_mmh_fines'
                        name='fines'
                        className={
                            TRAFFIC_SUB_VIEW_MODEL.MANAGE.FINES === subView
                                ? 'btn-outlined-secondary-600-100 w-100 mr-8px'
                                : 'btn-outlined-secondary-600-00 w-100 mr-8px'
                        }
                        disabled={false}
                        splitName={false}
                        onClick={() => {
                            handleSubViewChange(TRAFFIC_SUB_VIEW_MODEL.MANAGE.FINES);
                        }}
                    />
                    )}

                    {(DEV || permission?.includes(permissionObj?.WEB_TRAFFIC_MANAGE_GEOFENCES_READ)) && (
                    <ButtonAction
                        id='btn_mmh_geofences'
                        name='geofences'
                        className={
                            TRAFFIC_SUB_VIEW_MODEL.MANAGE.GEOFENCES === subView
                                ? 'btn-outlined-secondary-600-100 w-100 mr-8px'
                                : 'btn-outlined-secondary-600-00 w-100 mr-8px'
                        }
                        disabled={false}
                        splitName={false}
                        onClick={() => {
                            handleSubViewChange(TRAFFIC_SUB_VIEW_MODEL.MANAGE.GEOFENCES);
                        }}
                    />
                    )}

                </div>
                {  TRAFFIC_SUB_VIEW_MODEL.MANAGE.GEOFENCES === subView &&
                    <div className='w-100'>
                        <CustomSearch
                            id={"txt_mmh_search_icon"}
                            label={'type_something_to_search'}
                            value={searchElement}
                            setValue={setSearchElement}
                            onChange={(e) => setSearchElement(e.target.value)}
                            onReset={()=> setSearchElement("")}
                        />
                    </div>
                }
            </div>
        </>
    );
};

export default ManageMainHeader;
